import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useQueryClient
} from "@tanstack/react-query"

import client from "utils/client"
import { getNextPageParam } from "shared/lib/ransack"

export const useActivityEvents = (params) => {
  return useInfiniteQuery({
    queryKey: ["v2", "activities", "events", "index", params],
    queryFn: async ({ pageParam = 1 }) => {
      const res = await client.get("/v2/activities/events.json", {
        params: { ...params, page: pageParam }
      })

      return res.data
    },
    getNextPageParam
  })
}

export const useActivityEvent = (id, options = {}) => {
  return useQuery({
    queryKey: ["v2", "activities", "events", "show", id],
    queryFn: async () => {
      const response = await client.get(`/v2/activities/events/${id}.json`)

      return response.data
    },
    enabled: !!id,
    ...options
  })
}

export const useUpdateActivityEvent = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, ...values }) => {
      const response = await client.put(`/v2/activities/events/${id}.json`, {
        activity_event: values
      })

      return response.data
    },

    onSuccess: () => {
      queryClient.invalidateQueries(["v2", "activities", "events", "index"])
      queryClient.invalidateQueries(["v2", "activities", "events", "show"])
      queryClient.invalidateQueries(["v2", "activities", "tasks", "index"])
      queryClient.invalidateQueries(["v2", "activities", "feed_items", "index"])
    }
  })
}

export const useCreateActivityEvent = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (values) => {
      const response = await client.post("/v2/activities/events.json", {
        activity_event: values
      })

      return response.data
    },

    onSuccess: () => {
      queryClient.invalidateQueries(["v2", "activities", "events", "index"])
      queryClient.invalidateQueries(["v2", "activities", "feed_items", "index"])
    }
  })
}

export const useDeleteActivityEvent = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (id) => {
      const response = await client.delete(`/v2/activities/events/${id}.json`)

      return response.data
    },

    onSuccess: () => {
      queryClient.invalidateQueries(["v2", "activities", "events", "index"])
      queryClient.invalidateQueries(["v2", "activities", "feed_items", "index"])
    }
  })
}
